// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


//---------------------------------ジョンカスタマイズ-----------------------------------
//--------------------------ランキングバッジとロードモア--------------------------------
// Step 1: Find elements with class .featured-collection-slider__inner
var sliders = document.getElementsByClassName('featured-collection-slider__inner');

// Step 2: Loop through the sliders
for (var i = 0; i < sliders.length; i++) {
  var slider = sliders[i];
  
  // Check if the nested h2 tag contains the word "ランキング"
  var nestedH2 = slider.querySelector('h2');
  if (nestedH2 && nestedH2.textContent.includes('ランキング')) {
    
    // Step 3: Find the first .product-item and add a gold badge
    var firstMedia = slider.querySelector('.swiper-slide');
    if (firstMedia) {
      addBadge(firstMedia, '1', 'gold');
    }
    
    // Step 4: Find the second .product-item and add a silver badge
    var secondMedia = slider.querySelector('.swiper-slide:nth-child(2)');
    if (secondMedia) {
      addBadge(secondMedia, '2', 'silver');
    }
    
    // Step 5: Find the third .product-item and add a bronze badge
    var thirdMedia = slider.querySelector('.swiper-slide:nth-child(3)');
    if (thirdMedia) {
      addBadge(thirdMedia, '3', 'bronze');
    }
    
    // Step 6: Find the fourth .product-item and add a dark grey badge
    var fourthMedia = slider.querySelector('.swiper-slide:nth-child(4)');
    if (fourthMedia) {
      addBadge(fourthMedia, '4', 'darkgrey');
    }

    // Step 7: Find the fifth .product-item and add a dark grey badge
    var fifthMedia = slider.querySelector('.swiper-slide:nth-child(5)');
    if (fifthMedia) {
      addBadge(fifthMedia, '5', 'darkgrey');
    }
  }
}


// Step 1: Check if the body has the class ".template-collection"
if (document.body.classList.contains('template-collection')) {
  // Step 2: Find nested h1 tags containing the word "ランキング"
  var h1Tags = document.body.querySelectorAll('.template-collection h1');
  for (var i = 0; i < h1Tags.length; i++) {
    var h1Tag = h1Tags[i];
    if (h1Tag.textContent.includes('ランキング')) {
      // Step 3: Find parent .template-collection element
      var templateCollection = h1Tag.closest('.template-collection');
      if (templateCollection) {
        // Step 4: Find nested .product-item elements
        var productItems = templateCollection.querySelectorAll('.product-item');
        for (var j = 0; j < productItems.length; j++) {
          var productItem = productItems[j];
          // Step 5: Add badges based on position
          if (j === 0) {
            addBadge(productItem, '1', 'gold');
          } else if (j === 1) {
            addBadge(productItem, '2', 'silver');
          } else if (j === 2) {
            addBadge(productItem, '3', 'bronze');
          } else if (j === 3) {
            addBadge(productItem, '4', 'darkgrey');
          } else if (j === 4) {
            addBadge(productItem, '5', 'darkgrey');
          }
        }
      }
    }
  }
}


// Helper function to add a badge to an element
function addBadge(element, number, color) {
  var badge = document.createElement('span');
  badge.className = 'badge ' + color;
  badge.textContent = number;
  element.appendChild(badge);
}


// Get the .collection__infinite-trigger element
const triggerElement = document.querySelector('.collection__infinite-trigger');

// Create an Intersection Observer instance
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // Scroll trigger element is in view, find and click the child link element
      const linkElement = entry.target.querySelector('a'); // Replace 'a' with the appropriate selector for your child link element
      linkElement.click();
    }
  });
});

// Start observing the trigger element
observer.observe(triggerElement);
